import { render, staticRenderFns } from "./CurrentMentorshipItem.vue?vue&type=template&id=56d78a8c&scoped=true&"
import script from "./CurrentMentorshipItem.vue?vue&type=script&lang=js&"
export * from "./CurrentMentorshipItem.vue?vue&type=script&lang=js&"
import style0 from "./CurrentMentorshipItem.vue?vue&type=style&index=0&id=56d78a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d78a8c",
  null
  
)

export default component.exports